function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Utility that allows to subscribe to and from events.
 * It also contains the enum of possible events.
 *
 * Event listener is invoked when the corresponding method is called. Listener receives promise of the future result
 * and the event object.
 *
 * Promise is resolved with corresponding object, depending on event, e.g. Folder, Item or List
 *
 * Promise is rejected with RejectReason object
 *
 * @namespace mediaManagerSDK.events
 * @memberof mediaManagerSDK
 *
 * @snippet subscribe.js
 */

/**
 * @typedef RejectReason
 * @type Object
 * @property {number} code
 * @property {string} message
 * @property {object} data
 *
 * @snippet codes.md
 */

/**
 * @typedef Event
 * @type Object
 * @property {object} eventTarget
 * @property {const} eventName
 */
import { addListener, removeListener } from './notifier';
import { eventsList } from './list';

var events = _objectSpread({}, eventsList);

function defineNonEnumerableProperty(name, value) {
  Object.defineProperty(events, name, {
    enumerable: false,
    value: value
  });
}

defineNonEnumerableProperty('on', addListener);
defineNonEnumerableProperty('off', removeListener);
export { events };